import { jsPDF } from "jspdf";
import { canal, format as fmt, frequence as freq, jour, statut } from "variables/veille";

// Construit un VRAI document PDF (A4) de cadrage de la veille — sans aucune statistique.
// Sert à la fois à l'aperçu intégré (iframe) et au téléchargement.
export function construireDocVeille(v) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 48;
  const contentW = W - M * 2;

  // --- Bandeau d'en-tête sombre ---
  doc.setFillColor(21, 25, 40); // #151928
  doc.rect(0, 0, W, 138, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(79, 209, 197); // teal
  doc.text("DOCUMENT DE VEILLE MÉDIA", M, 48);

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(20);
  const titre = doc.splitTextToSize(v.nom || "Veille", contentW - 100);
  doc.text(titre, M, 74);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(200, 205, 220);
  doc.text(`${v.client || "—"}  ·  ${v.secteur || "—"}`, M, 76 + titre.length * 22);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(255, 255, 255);
  doc.text("Wave Veille", W - M, 48, { align: "right" });

  let y = 176;
  const section = (label) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(120, 128, 150);
    doc.text(label.toUpperCase(), M, y);
    y += 8;
    doc.setDrawColor(230, 232, 240);
    doc.line(M, y, W - M, y);
    y += 20;
  };
  const paragraphe = (txt) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(45, 50, 70);
    const lignes = doc.splitTextToSize(txt || "—", contentW);
    doc.text(lignes, M, y);
    y += lignes.length * 16 + 16;
  };
  const paire = (label, valeur) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(120, 128, 150);
    doc.text(label, M, y);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(45, 50, 70);
    const lignes = doc.splitTextToSize(valeur || "—", contentW - 160);
    doc.text(lignes, M + 160, y);
    y += Math.max(lignes.length * 15, 18) + 8;
  };

  section("Objectif de la veille");
  paragraphe(
    v.demande && v.demande.trim()
      ? v.demande.trim()
      : `Surveiller la présence média de ${v.client || v.nom} sur le secteur « ${v.secteur || "—"} », détecter les retombées et en produire une synthèse régulière au rythme convenu.`
  );

  section("Périmètre surveillé");
  paire("Secteur", v.secteur);
  paire("Mots-clés", (v.motsCles || []).join(", "));
  paire("Canaux couverts", (v.canaux || []).map((c) => (canal(c) || {}).label || c).join(", "));
  if ((v.sources || []).length) paire("Sources spécifiques", v.sources.join(", "));

  section("Paramètres de diffusion");
  paire("Format du rapport", (fmt(v.format) || {}).label);
  paire("Fréquence d'envoi", (freq(v.frequence) || {}).label);
  if (v.frequence !== "temps_reel" && (v.jours || []).length) paire("Jours d'envoi", v.jours.map((j) => (jour(j) || {}).label || j).join(", "));
  if (v.frequence !== "temps_reel" && v.heure) paire("Heure d'envoi", v.heure);
  const dest = Array.isArray(v.destinataires) ? v.destinataires : (v.destinataires ? [v.destinataires] : []);
  if (dest.length) paire("Destinataires", dest.join(", "));
  paire("Responsable", v.responsable);
  paire("Prochaine échéance", v.prochaineDate);
  paire("Statut", (statut(v.statut) || {}).label);

  // --- Pied de page ---
  doc.setDrawColor(230, 232, 240);
  doc.line(M, H - 58, W - M, H - 58);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(150, 155, 170);
  doc.text("Document généré par Wave Veille", M, H - 40);
  if (v.responsable) doc.text(v.responsable, W - M, H - 40, { align: "right" });

  return doc;
}

// URL blob pour l'aperçu intégré. Pensez à révoquer l'URL quand elle n'est plus utilisée.
export function apercuUrlVeille(v) {
  return URL.createObjectURL(construireDocVeille(v).output("blob"));
}

export function telechargerDocVeille(v) {
  const base = (v.client || v.nom || "document")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
  construireDocVeille(v).save(`veille-${base}.pdf`);
}
